import { fetchWithAuth, IMAGE_URL, resolvePayload } from "./const.routes.ts";
import { ContextType, FileType } from "../types/File";
import { ErrorType, parseError } from "../types/Error/Errors.ts";
import { err, Result } from "../types/Result.ts";

export async function uploadFiles(
  files: File[],
  context: ContextType,
  contextId: string,
): Promise<Result<FileType[], ErrorType>> {
  const fileFormData = new FormData();
  fileFormData.append("context", context);
  fileFormData.append("contextId", contextId);
  files.forEach((file) => {
    fileFormData.append("images", file);
  });

  try {
    const imageResponse = await fetchWithAuth(IMAGE_URL, {
      method: "POST",
      body: fileFormData,
    });
    return await resolvePayload(imageResponse);
  } catch (e) {
    return err(parseError(e));
  }
}

export async function uploadFileType(
  newFile: FileType,
  context: ContextType,
  contextId: string,
) {
  const response = await fetch(newFile.basename);
  const blob = await response.blob();
  const file = new File([blob], "filename.jpg", { type: blob.type });
  const result = await uploadFiles([file], context, contextId);
  if (!result.ok) {
    return result.error;
  }
  return result.value[0];
}

export async function deleteFiles(
  fileIds: string[],
  context: ContextType,
  contextId: string,
): Promise<Result<string, ErrorType>> {
  try {
    const imageResponse = await fetchWithAuth(IMAGE_URL, {
      method: "delete",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        files: fileIds,
        context: context,
        contextId: contextId,
      }),
    });
    return await resolvePayload(imageResponse);
  } catch (e) {
    console.error(e);
    return err(parseError(e));
  }
}

export async function uploadFile(
  file: File,
  context: ContextType,
  contextId: string,
): Promise<Result<FileType, string>> {
  const fileUrl = await uploadFiles([file], context, contextId);
  if (fileUrl.ok) {
    return { ok: true, value: fileUrl.value[0] };
  } else {
    return { ok: false, error: fileUrl.error };
  }
}

export async function urlToFile(
  url: string,
  filename: string,
  mimeType: string,
) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: mimeType });
}
